export const COVER_PAGE = 'coverPage';
export const GAME_PAGE = 'gamePage';
export const SUCCESS_PAGE = 'successPage';
export const FAIL_PAGE = 'failPage';
export const RESULT_PAGE = 'resultPage';

export const pageList = [
    {
        type: COVER_PAGE,
        name: 'label.memoryMatch.pageType.cover',
        group: 'cover'
    },
    {
        type: GAME_PAGE,
        name: 'label.memoryMatch.pageType.game',
        group: 'join'
    },
    {
        type: RESULT_PAGE,
        name: 'label.page_list.result_page',
        group: 'result'
    },
    {
        type: SUCCESS_PAGE,
        name: 'label.memoryMatch.pageType.success',
        group: 'result'
    },
    {
        type: FAIL_PAGE,
        name: 'label.memoryMatch.pageType.fail',
        group: 'result'
    }
];
